__turbopack_context__.v({
  "JourneyForGraduation__Container": "JourneyForGraduation-module-scss-module__o8S3HG__JourneyForGraduation__Container",
  "JourneyForGraduation__ContainerTitle": "JourneyForGraduation-module-scss-module__o8S3HG__JourneyForGraduation__ContainerTitle",
  "JourneyForGraduation__ImageContainer": "JourneyForGraduation-module-scss-module__o8S3HG__JourneyForGraduation__ImageContainer",
  "campusemmursion": "JourneyForGraduation-module-scss-module__o8S3HG__campusemmursion",
  "root": "JourneyForGraduation-module-scss-module__o8S3HG__root",
});
